var map = {
	"./AHealthierTomorrow/React/FrontEnd/customComponentIndex.ts": [
		8568,
		8568
	],
	"./laxhjalpen/React/FrontEnd/customComponentIndex.ts": [
		1297,
		1297
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4092;
module.exports = webpackAsyncContext;